export default __webpack_public_path__ + "static/media/spotFooter.91abf0fc.svg";